import React, { useEffect,useState } from "react";
import { Empty,Pagination } from "antd";


import Table from "../../Table";
import "./nuJobsAllResumes.scss";
import useSourcingStore from "../../../store/sourcing.store";
import FilterSourcing from "../../filterSourcing";

export default function NuJobsAllResumes(props) {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
   const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const { nuJobsAllResumes,getNuJobsAllResumes,nuJobsAllResumesTotalCount,nuJobsAllApplications } = useSourcingStore();

  useEffect(() => {
  }, []);

  const titleList = [
    "Sr. No.",
    "Client",  
    "TA",
    "JD Title",    
    "Name", 
    "Email",
    "Phone",
    "Application Status",
    "Applied On",
    "Current Location",
    "Total Experience",
    "Current CTC",
    "Expected CTC",
    "Notice Period",
    "LWD",
    "Qualification",
    "Resume Suitability",
  ];
 
  function formatUnixDate(ts) {
      const d = new Date(ts * 1000);
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      const yyyy = d.getFullYear();

      return `${dd}-${mm}-${yyyy}`;
    }  
  

  const sDetailData = nuJobsAllApplications?.map((item, idx) => {

    const jd = item.jds
    const resume = item.resume?.[0].myresume
    return {
      id: (idx + 1)+ (currentPage-1)*pageSize, 
      client_name: jd?.jdclient?.clientname,
      ta_name: jd?.jdclient?.taname,
      title: '['+jd?.qhcompanyjid+'] '+jd?.jddetails?.title,
      name: resume.personaldetail?.name,
      email: resume.personaldetail?.email,
      phone: resume.personaldetail?.mobile,
      status: item.nujobsinfo.applicationstatus,
      appliedon: item.nujobsinfo.appliedon,
      currentlocation: resume.employmentdetails?.currentlocation,
      totalexperience: item.resume?.[0].newemploymentdetails.totalexp,
      currentctc: resume.employmentdetails?.currentctc.totalctc,
      expectedctc: item.resume?.[0].newemploymentdetails.ectc.totalctc,
      noticeperiod: resume.employmentdetails?.noticeperiod.officialnp,
      lwd: resume.employmentdetails?.noticeperiod.lwd?resume.employmentdetails?.noticeperiod.lwd:"-",
      qualification: resume.educationaldetail?.maxdegree,
      // The following two fields are placeholders and should be replaced with actual logic  
      resumeSuitability: "UPGRADE TO QHRFLOW",
    };
  });

  return (
    <div className="nujobs-allresumes-wrapper">
      <div>
      <FilterSourcing
        filtername = {"getNuJobsAllResumes"}
        initRange={"24"}
        initPrio={"All"}
        initJDStatus={"Active"} 
        pageNo = {currentPage}
        pageSize = {pageSize}        
        enableTAs 
        enableRange
        enablePriority
        enableJdStatus
        enableCustomers
        handleFilter={getNuJobsAllResumes}
        setCurrentPage={setCurrentPage}
      />
      <div></div>
      </div>
      <div className="sourcing-title">
       ({nuJobsAllResumesTotalCount || 0}){" "} Applications Received 
      </div>
      <div>
        {sDetailData?.length > 0 ? (
          <Table
            isClickable={true}
            isJDPage={true}
            titleList={titleList}
            data={sDetailData}
            columnWidth={[
              50, 100, 100, 200, 200, 200, 100, 100, 100, 100, 100, 100,
              100, 100, 100, 100,100
            ]}
            currentProduct = {"nujobs"}
          />
        ) : (
          <Empty style={{ margin: "60px" }} />
        )}        
      </div>
       <Pagination
              style={{ margin: "20px",  float: "inline-end" }}
              current={currentPage}
              pageSize={pageSize}
              total={nuJobsAllResumesTotalCount}
              onChange={(page, pageSize) => {
                handlePageChange(page, pageSize);
                
              }}
              showSizeChanger
              pageSizeOptions={[10, 20, 50, 100, 150]}
            />      

    </div>
  );
}
